import upravaMihalnicObocia from "../../assets/procedury/uprava-mihalnic-obocie.png";
import osetreniaPleti from "../../assets/procedury/osetrenie-pleti.png";
import pristrojoveOsetreniaPleti from "../../assets/procedury/pristrojove-osetrenie-pleti.png";
import plasmaPen from "../../assets/procedury/plasma-pen.png";
import permanentnyMakeup from "../../assets/procedury/permanentny-makeup.png";
import { IProceduraData } from "../../Utils/Interfaces/procedury.interface";

export const proceduryData: IProceduraData[] = [
  {
    id: 1,
    title: "Ošetrenia pleti",
    image: osetreniaPleti,
    summary:
      "Snívate o pleti, ktorá je nielen čistá, ale aj hlboko vyživená, zregenerovaná a plná zdravého lesku? V našom salóne veríme, že cesta k dokonalej pleti vedie cez..",
    description: (
      <>
        <p>
          Snívate o pleti, ktorá je nielen čistá, ale aj hlboko vyživená,
          zregenerovaná a plná zdravého lesku? V našom salóne veríme, že cesta k
          dokonalej pleti vedie cez precízny a individuálny prístup. Naše
          protokolárne ošetrenia predstavujú základ starostlivosti, ktorá
          prináša viditeľné a trvalé zlepšenie.
        </p>
        <p>
          Nejde len o klasické čistenie - každé ošetrenie je starostlivo
          navrhnutý rituál, ktorý kombinuje moderné techniky, prvotriednu
          kozmetiku a odborné vedomosti našich terapeutiek.
        </p>
        <p>
          <strong>Čo môžete očakávať:</strong>
        </p>
        <ul style={{ marginLeft: "3rem", marginBottom: "1rem" }}>
          <li>Hĺbkové čistenie a detoxikáciu</li>
          <li>Intenzívnu hydratáciu a výživu</li>
          <li>Regeneráciu a obnovu pokožky</li>
          <li>Individuálny prístup</li>
          <li>Relaxačný zážitok</li>
        </ul>
        <p>
          <strong>
            Vaša cesta k zdravej a žiarivej pleti začína práve tu:
          </strong>
        </p>
        <p>
          Naše komplexné ošetrenia zahŕňajú jemné odlíčenie, tonizáciu, hĺbkové
          čistenie (manuálne alebo s pomocou technológií podľa typu pleti),
          aplikáciu sér a koncentrátov, špeciálne masky a záverečnú krémovú
          starostlivosť. Každý krok je navrhnutý tak, aby vaša pleť dostala to
          najlepšie.
        </p>
        <p>
          Investujte do krásy, ktorá pramení zo zdravia. Objednajte sa na
          profesionálne ošetrenie a zažite, ako sa vaša pleť premení na žiarivú
          vizitku vašej osobnosti.
        </p>
      </>
    ),
  },
  {
    id: 2,
    title: "Prístrojové ošetrenia pleti",
    image: pristrojoveOsetreniaPleti,
    summary:
      "Preskúmajte novú úroveň starostlivosti o pleť vďaka našim prístrojovým ošetreniam. Ak túžite po pleti, ktorá žiari zdravím, vitalitou a mladistvým vzhľadom, v salóne...",
    description: (
      <>
        <p>
          Preskúmajte novú úroveň starostlivosti o pleť vďaka našim prístrojovým
          ošetreniam.
        </p>
        <p>
          Ak túžite po pleti, ktorá žiari zdravím, vitalitou a mladistvým
          vzhľadom, v salóne MAYA beauty spájame krásu s vedou a inováciami.
          Ponúkame špičkové prístrojové ošetrenia, ktoré zmenia vašu
          starostlivosť o pleť na komplexný zážitok a prinášajú hĺbkovú
          transformáciu.
        </p>
        <p>
          Naše technológie cielia na širokú škálu problémov pleti a prinášajú
          viditeľné a trvalé výsledky. Či už vás trápia vrásky, suchá pleť,
          akné, pigmentové škvrny alebo jednoducho chcete dodať pleti maximálnu
          dávku výživy a omladenia, u nás nájdete riešenie.
        </p>
        <p>
          <strong>Prečo si zamilujete naše prístrojové ošetrenia?</strong>
        </p>
        <ul style={{ marginLeft: "3rem", marginBottom: "1rem" }}>
          <li>
            <strong>Hĺbková obnova a regenerácia:</strong> Vďaka inovatívnym
            technológiám prenikáme tam, kam bežná kozmetika nedosiahne. Aktívne
            látky sa dopravujú hlboko do pokožky pre maximálnu účinnosť.
          </li>
          <li>
            <strong>Viditeľné a okamžité výsledky:</strong> Pocítite a uvidíte
            rozdiel už po prvom ošetrení - pleť bude hydratovanejšia, pevnejšia
            a plná jasu.
          </li>
          <li>
            <strong>Bezbolestné a relaxačné zážitky:</strong> Väčšina procedúr
            je nielen účinná, ale aj príjemná a upokojujúca. Doprajte si chvíľu
            relaxu.
          </li>
          <li>
            <strong>Riešenie pre každý typ pleti:</strong> Naše ošetrenia
            prispôsobujeme individuálne podľa potrieb vašej pokožky.
          </li>
        </ul>
        <p>
          <strong>Ponorte sa do sveta najmodernejších technológií:</strong>
        </p>
        <p>
          Elektroporácia pre hĺbkové zapracovanie látok, rádiofrekvencia na
          stimuláciu kolagénu, nanohydratácia pre intenzívnu hydratáciu,
          ultrazvukové čistenie či mikrodermabrázia a hydrabrázia pre jemnú
          exfoliáciu.
        </p>
        <p>
          Pre problematickú pleť a akné ponúkame Plasma Ozón s antibakteriálnymi
          účinkami, cold hlavicu na upokojenie a zmenšenie pórov a fotónovú
          terapiu pre vitalizáciu pokožky.
        </p>
        <p>
          Každé ošetrenie je podporené modernými prístrojmi a odbornými
          vedomosťami nášho tímu. Dovoľte nám pomôcť vám dosiahnuť pleť, o akej
          snívate.
        </p>
      </>
    ),
  },
  {
    id: 3,
    title: "Úprava mihalníc a obočia",
    image: upravaMihalnicObocia,
    summary:
      "Oči sú zrkadlom duše a s nami sa stanú vašou najvýraznejšou vizitkou! Dokonalé obočie a podmanivé mihalnice dokážu úplne zmeniť výraz tváre a zvýrazniť vašu prirodzenú...",
    description: (
      <>
        <p>
          Oči sú zrkadlom duše a s nami sa stanú vašou najvýraznejšou vizitkou!
          Dokonalé obočie a podmanivé mihalnice dokážu úplne zmeniť výraz tváre
          a zvýrazniť vašu prirodzenú krásu.
        </p>
        <p>
          Zabudnite na každodenné starosti s líčením - s našimi službami sa
          budete prebúdzať s bezchybným pohľadom.
        </p>
        <p>
          Ponúkame komplexnú úpravu a farbenie obočia, ktoré precízne
          vytvarujeme do ideálneho oblúka, zvýrazníme farbu a vyplníme medzery
          pre perfektný vzhľad.
        </p>
        <p>
          <strong>Pudrové tetovanie obočia:</strong>
        </p>
        <ul style={{ marginLeft: "3rem", marginBottom: "1rem" }}>
          <li>Dlhotrvajúce, prirodzené a efektívne riešenie</li>
          <li>Opticky hustejšie obočie</li>
          <li>Korekcia asymetrie</li>
          <li>Odolnosť voči vode a potu</li>
        </ul>
        <p>
          <strong>Premeňte svoje mihalnice:</strong>
        </p>
        <ul style={{ marginLeft: "3rem", marginBottom: "1rem" }}>
          <li>
            Farbenie mihalníc: tmavšie a výraznejšie riasy bez potreby riasenky
          </li>
          <li>
            Lash lifting: zatočené a nadvihnuté mihalnice s efektom riasenky
          </li>
          <li>3D predlžovanie mihalníc: dramatický a hustý vzhľad</li>
        </ul>
        <p>
          <strong>Prečo si vybrať nás?</strong>
        </p>
        <ul style={{ marginLeft: "3rem", marginBottom: "1rem" }}>
          <li>Individuálny prístup</li>
          <li>Profesionálne produkty</li>
          <li>Dlhotrvajúce výsledky</li>
          <li>Úspora času pri líčení</li>
        </ul>
        <p>
          Doprajte si premenu, ktorá zvýrazní vašu krásu a dodá vám sebavedomie.
        </p>
      </>
    ),
  },
  {
    id: 4,
    title: "Permanentný make-up",
    image: permanentnyMakeup,
    summary:
      "Prebuďte sa každý deň krásna a sebavedomá bez potreby líčenia. Permanentný make-up je ideálny pre ženy, ktoré chcú vždy upravený vzhľad bez každodenného nanášania...",
    description: (
      <>
        <p>
          Prebuďte sa každý deň krásna a sebavedomá bez potreby líčenia.
          Permanentný make-up je ideálny pre ženy, ktoré chcú vždy upravený
          vzhľad bez každodenného nanášania mejkapu.
        </p>
        <p>
          V salóne MAYA beauty ponúkame precízne, prirodzene pôsobiace
          ošetrenia, ktoré zvýraznia vašu krásu a ušetria vám čas.
        </p>
        <p>
          <strong>Čo je permanentný make-up?</strong>
        </p>
        <p>
          Ide o jemnú mikropigmentáciu, pri ktorej sa do vrchných vrstiev
          pokožky aplikujú prírodné pigmenty. Výsledok je efekt nalíčenia, ktorý
          vydrží mesiace až roky a je vhodný na obočie, oči alebo pery.
        </p>
        <p>
          <strong>Naše služby zahŕňajú:</strong>
        </p>
        <ul style={{ marginLeft: "3rem", marginBottom: "1rem" }}>
          <li>
            Precízne tvarovanie a tieňovanie obočia pre zvýraznenie pohľadu a
            symetriu tváre
          </li>
          <li>
            Delikátne linky na viečkach pre optické zväčšenie očí bez potreby
            každodenného líčenia
          </li>
          <li>Prírodné zvýraznenie pier pre farbu a tvar bez rúžu</li>
        </ul>
        <p>
          <strong>Prečo si vybrať permanentný make-up u nás?</strong>
        </p>
        <ul style={{ marginLeft: "3rem", marginBottom: "1rem" }}>
          <li>
            Individuálny prístup - výber odtieňa a tvaru podľa typu pleti a
            štýlu
          </li>
          <li>
            Kvalita a bezpečnosť - certifikované pigmenty a sterilné techniky
          </li>
          <li>Dlhodobý efekt - ušetríte čas a energiu</li>
          <li>
            Profesionálna starostlivosť - komfort počas zákroku a poradenstvo po
            aplikácii
          </li>
        </ul>
        <p>
          Doprajte si krásu, ktorá vydrží, a objednajte sa na konzultáciu ešte
          dnes.
        </p>
      </>
    ),
  },
  {
    id: 5,
    title: "Plasma Pen",
    image: plasmaPen,
    summary:
      "Túžite po viditeľnom omladení bez chirurgického zákroku? Prinášame prelomové technológie Plasma Pen a Fibroblast - neinvazívnu revolúciu v estetickej medicíne...",
    description: (
      <>
        <p>
          <strong>
            Revolúcia v omladzovaní: Plasma Pen a Fibroblast pre obnovu krásy
            pleti.
          </strong>
        </p>
        <p>
          Túžite po viditeľnom omladení bez chirurgického zákroku? Prinášame
          prelomové technológie Plasma Pen a Fibroblast - neinvazívnu revolúciu
          v estetickej medicíne.
        </p>
        <p>
          Tieto špičkové metódy cielene riešia vrásky, ochabnutú pleť, jazvy a
          ďalšie nedokonalosti s ohromujúcimi výsledkami.
        </p>
        <p>
          <strong>Plasma Pen & Fibroblast:</strong>
        </p>
        <p>
          Plasma Pen využíva plazmový výboj, ktorý vytvára mikroskopické body na
          pokožke. Tento proces stimuluje sťahovanie kolagénu a spúšťa
          intenzívnu regeneráciu. Cieľom je:
        </p>
        <ul style={{ marginLeft: "3rem", marginBottom: "1rem" }}>
          <li>
            Neinvazívny lifting očných viečok - redukcia prebytočnej kože a
            vyhladenie vrások
          </li>
          <li>Redukcia vrások a jemných liniek na tvári, krku a dekolte</li>
          <li>Zlepšenie elasticity pleti pre pevnejší a pružnejší vzhľad</li>
          <li>
            Odstránenie kožných nerovností ako jazvy, strie a pigmentové škvrny
          </li>
        </ul>
        <p>
          Procedúra Fibroblast stimuluje tvorbu nového kolagénu a elastínu, čo
          vedie k dlhodobému omladeniu a remodelácii pleti.
        </p>
        <p>
          <strong>Prečo si vybrať Plasma Pen u nás?</strong>
        </p>
        <ul style={{ marginLeft: "3rem", marginBottom: "1rem" }}>
          <li>Minimálne invazívna - bez rezov, ihiel a dlhého zotavenia</li>
          <li>Viditeľné a trvalé výsledky už po jednom ošetrení</li>
          <li>Presnosť a bezpečnosť v rukách skúsených odborníkov</li>
          <li>Prirodzený výsledok bez umelého efektu</li>
          <li>Komplexné riešenie viacerých estetických problémov naraz</li>
        </ul>
        <p>
          Objavte potenciál vašej pleti s Plasma Pen a vráťte jej mladistvý
          vzhľad. Radi vás privítame na konzultácii, kde vám navrhneme najlepší
          plán ošetrenia.
        </p>
      </>
    ),
  },
];
